import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 110 126",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M46.2659 124.722C26.1654 120.693 0.176483 106.233 0.176483 68.8424C0.176483 34.8164 25.0828 12.1584 42.9919 1.74735C46.9659 -0.56284 51.6182 2.47535 51.6182 7.07203V18.8296C51.6182 28.101 55.5164 45.0244 66.3478 52.0635C71.8778 55.6574 77.8502 50.2784 78.5223 43.7176L79.0742 38.3301C79.7158 32.067 86.0944 28.265 91.1001 32.0835C100.093 38.9435 109.49 50.9562 109.49 68.8424C109.49 114.568 75.4815 126 58.4771 126C57.4881 126 56.4487 125.97 55.3667 125.908C52.4993 125.547 55.3667 126.546 46.2659 124.722Z",
      fill: "#FB923C"
    }, null, -1),
    _createElementVNode("path", {
      d: "M83.5117 100.019C83.5117 119.237 67.9961 125.18 58.4003 125.998C55.1233 125.586 58.4003 126.726 47.9994 124.645C40.3666 121.953 32.07 115.042 32.07 100.019C32.07 90.4992 38.0858 84.6257 42.7987 81.8763C44.2404 81.0352 45.9147 82.0942 46.0436 83.7561C46.4522 89.024 51.5195 93.2197 54.9716 89.2144C58.0223 85.6749 59.3038 80.5044 59.3038 77.1966V72.8743C59.3038 70.2685 61.9316 68.5421 64.1768 69.8717C72.5247 74.8152 83.5117 84.9855 83.5117 100.019Z",
      fill: "#FBBF24"
    }, null, -1)
  ])))
}
export default { render: render }